module.exports = __webpack_public_path__ + "static/project-pastebin-1d89c5e94cd31414b9bb3ca660ecec93.png";